import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import FormField from '@@client/components/FormField';
export default function FormOneliner(_ref) {
  var id = _ref.id,
      before = _ref.before,
      after = _ref.after,
      children = _ref.children,
      formFieldAtts = _objectWithoutProperties(_ref, ["id", "before", "after", "children"]);

  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    inputId: id
  }, formFieldAtts), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "input-line",
      children: [before, children, after]
    })
  }));
}